function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M53.9963 21.6732C53.9963 14.8859 48.5366 9.38354 41.8019 9.38354C38.4698 9.38354 35.449 10.732 33.2473 12.9173V12.9472C33.4363 13.7017 33.5735 14.4787 33.6513 15.2669C34.7484 20.9485 38.2251 34.8406 45.7123 33.2157L46.8205 32.872C51.0533 30.9445 54 26.6562 54 21.6694L53.9963 21.6732Z",
  fill: "url(#paint0_linear_2663_106)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M46.8168 32.8756L45.7086 33.2193C38.2214 34.8405 34.7484 20.9484 33.6476 15.2705C33.5698 14.4786 33.4326 13.7053 33.2473 12.9508V12.9209H33.2399C31.4311 5.50231 24.7891 0 16.8683 0C7.55385 0 0 7.61283 0 17C0 26.3872 7.55385 34 16.8683 34L41.8019 33.9626C42.4913 33.9626 43.1696 33.9029 43.8294 33.7908H43.8627L43.8887 33.7796C44.9042 33.604 45.8791 33.2977 46.7909 32.8868C46.8094 32.8794 46.8242 32.8756 46.8427 32.8682L46.8168 32.8756Z",
  fill: "url(#paint1_linear_2663_106)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_2663_106",
  x1: 51.9392,
  y1: 28.834,
  x2: 34.5624,
  y2: 11.5919,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D8AE30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#D9B034"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#DFB842"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.61,
  stopColor: "#E8C459"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.84,
  stopColor: "#F4D679"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFE595"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_2663_106",
  x1: 0,
  y1: 17,
  x2: 46.8427,
  y2: 17,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CF5285"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.15,
  stopColor: "#D05688"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#D36491"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.52,
  stopColor: "#D87BA0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#DE9BB5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.92,
  stopColor: "#E7C4D0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ECD8DD"
})));

function SvgFaviconCouleur(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 34,
    viewBox: "0 0 54 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaviconCouleur);
export default __webpack_public_path__ + "static/media/favicon-couleur.0fd5b1fb466d12e16d42a53f03db1870.svg";
export { ForwardRef as ReactComponent };